import store from "../store";
import HelperFunctions from '@/classes/HelperFunctions';

export default async ( { next, router } ) => {
    if ( localStorage.getItem( 'auth_token' ) ) {
        if ( !store.getters['user/getUserId'] ) {
            await HelperFunctions.loadUser().then( () => {
                return router.push( { path: '/admin' } ).catch(()=>{});
            } ).catch( () => {
                return router.push( { name: 'admin.login' } ).catch(()=>{});
            } );
        }
        else
            return router.push( { path: '/admin' } ).catch(()=>{});
    }
    next();
}
